import { Button, Box } from 'theme-ui'

import CloseIcon from '../../icons/Close'

function ClearButton({ onClear }) {
    return (
        <Button
            sx={{
                fontSize: [1, 1, 1],
                py: [0, 0, 0],
                px: [2, 2, 2],
                display: 'flex',
                cursor: 'pointer',
                height: ['24px', '24px', '24px'],
                lineHeight: ['24px', '24px', '24px'],
            }}
            onClick={onClear}
        >
            Clear all{' '}
            <Box sx={{ ml: 2, mr: 1 }}>
                <CloseIcon />
            </Box>
        </Button>
    )
}

export default ClearButton
